var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bill-tick-view"},[_c('BillTick')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }